import { Tooltip } from "@material-ui/core";

import classes from "./DevelopIcon.module.css";

const DevelopIcon = () => {
  return (
    <Tooltip title="Đang phát triển">
      <span className={classes.developIcon}>
        <i className="fas fa-arrow-alt-circle-up"></i>
      </span>
    </Tooltip>
  );
};

export default DevelopIcon;
